import React from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { FormControlLabelProps } from '@mui/material';
import { Checkbox, FormControlLabel, Switch } from '@mui/material';

interface FormCheckboxProps extends Omit<FormControlLabelProps, 'control'> {
  name: string;
  control: Control<any>;
}

export const FormCheckbox: React.FC<FormCheckboxProps> = ({ name, control, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          {...props}
          control={
            <Switch
              checked={field.value ?? false}
              onChange={(e) => field.onChange(e.target.checked)}
              onBlur={field.onBlur}
              name={field.name}
              ref={field.ref}
            />
          }
        />
      )}
    />
  );
};
